<template>
  <div class="leave-dialog">
    <div class="box">
      <div class="content"></div>
      <div class="content">{{ message }}</div>
      <div class="btn">
        <img src="@/assets/images/return-dialog.png" alt="" @click="returnTo">
        <!-- <img src="@/assets/images/leave-dialog.png" alt="" @click="leave"> -->
        <!-- <div class="solid-btn" @click="leave" style="--bgc:#ffb842; --bsc: #c0811f;">確認</div> -->

      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ['message'],
  data() {
    return {

    }
  },
  methods: {
    returnTo() {
      this.$emit('closeDialog')
    },
    leave() {
      this.returnTo()
      this.$emit('confrim')
    }
  }
}
</script>

<style scoped lang="scss">
.leave-dialog {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, .4);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9;

  .box {
    width: 400px;
    height: 230px;
    background-color: #fff;
    border-radius: 20px;
    display: flex;
    flex-wrap: wrap;
    align-content: space-around;
    padding: 20px 0;
    box-sizing: border-box;
    .title {
      width: 100%;
      font-size: 30px;
      text-align: center;
      color: #B62D2E;
      font-weight: 700;
    }

    .content {
      font-size: 20px;
      width: 100%;
      text-align: center;
      padding-bottom: 30px;
    }

    .btn {
      width: 100%;
      display: flex;
      justify-content: center;

      img {
        height: 50px;
        width: auto;
        margin: 0 10px;
        cursor: pointer;

        &:hover {
          opacity: .7;
        }
      }

      .solid-btn {
        padding: 0 20px;
        height: 50px;
        width: 128px;
        line-height: 40px;
        border-radius: 50px;
        background-color: var(--bgc);
        color: var(--textc, #333);
        font-weight: 700;
        font-size: 18px;
        text-align: center;
        padding-top: 3px;
        position: relative;
        cursor: pointer;
        margin-left: 10px;

        &:before {
          content: '';
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          border-radius: 50px;
          box-shadow: inset 0px -4px 1px 0 var(--bsc);
        }

        &:hover {
          opacity: .7;
        }
      }
    }
  }
}
</style>